<template>
  <div>
    <a
      @click="buttonmob(flag)"
      class="fil-btn gb-button gb-button-11fb3e0f gb-button-text"
      id="fil-btn"
    >
      <img :src="btn_img" />
    </a>
    <div class="container">
      <ais-instant-search
        :routing="routing"
        :search-client="searchClient"
        index-name="kontou_products_simple"
      >
        <ais-configure :hits-per-page.camel="12" />
        <div class="search-panel">
          <div id="search-p" class="search-panel__filters">
            <div class="filtra-title el">
              <h2>ΤΑΞΙΝΟΜΗΣΗ</h2>
            </div>
            <div class="filtra-title en">
              <h2>SORT</h2>
            </div>
            <div class="sort el">
              <ais-sort-by
                :items="[
                  /* eslint-disable */
                  {label: 'Φθίνουσα Τιμή', value: 'kontou_products_simple/sort/price:desc'},
                  {label: 'Αύξουσα Τιμή', value: 'kontou_products_simple/sort/price:asc'},
                  {label: 'Πιο Δημοφιλή', value: 'kontou_products_simple/sort/sales:desc'},
                ]"
              />
            </div>
            <div class="sort en">
              <ais-sort-by
                :items="[
                  /* eslint-disable */
                  {label: 'Price: Low to High', value: 'kontou_products_simple/sort/price:desc'},
                  {label: 'Price: High to Low', value: 'kontou_products_simple/sort/price:asc'},
                  {label: 'Featured', value: 'kontou_products_simple/sort/sales:desc'},
                ]"
              />
            </div>
            <div class="filtra-title el">
              <h2>ΦΙΛΤΡΑ</h2>
            </div>
             <div class="filtra-title en">
              <h2>FILTERS</h2>
            </div>
            <!--<h2>Συγγραφέας</h2>
            <ais-refinement-list attribute="name" />-->
            
            <h2 class="el katigories">ΚΑΤΗΓΟΡΙΕΣ</h2>
            <h2 class="en katigories">CATEGORIES</h2>
            <ais-refinement-list
              class="collectio-re"
              :sort-by="['name:desc']"
              attribute="categories"
            />
            <ais-refinement-list class="rem" :sort-by="function(a,b) {
                  return brands.indexOf(a.name) - brands.indexOf(b.name);
                }" attribute="sub"/>

            
            <!--<ais-hierarchical-menu
              :attributes="['categories', 'collect']"
              :limit="100"
            ></ais-hierarchical-menu>-->
            <ais-configure
                query=""
                :disjunctive-facets-refinements.camel="{
                  category_id: categoryId,
                }"
              />
                      <!---->
            <ais-hierarchical-menu
              :attributes="['categories', 'collect']"
              :limit="1000"
              :show-parent-level="false"
              :transform-items="transformItems"
              :createURL="createURL"
            >
              <template>
                <div v-if="searc !== null">
                  <div v-if="en == true">
                    <ais-configure :query="searc" 
                    :disjunctive-facets-refinements.camel="{
                      lang: ['en'],
                    }"/>
                  </div>
                  <div v-else>
                    <ais-configure :query="searc"/>
                  </div>
                </div>
              </template>
            </ais-hierarchical-menu>
            <h2 class="el">ΤΙΜΗ</h2>
            <h2 class="en">PRICE</h2>
            <!--<ais-range-input attribute="price"></ais-range-input>-->
            <ais-range-input attribute="price">
              <template v-slot="{ currentRefinement, range, refine }">
                <vue-slider
                  :dot-style="{
                    background: '#3c497d',
                    borderColor: '#3c497d',
                    boxShadow: '0 0 2px 1px #3c497d',
                  }"
                  :tooltip-style="{ background: '#3c497d' }"
                  :process-style="{ background: '#3c497d' }"
                  :min="range.min"
                  :max="range.max"
                  :model-value="toValue(currentRefinement, range)"
                  @change="refine({ min: $event[0], max: $event[1] })"
                  step="1"
                  thumb-label="always"
                />
              </template>
            </ais-range-input>
          </div>

          <div class="search-panel__results">
            <div class="searchbox el">
              <ais-search-box placeholder="Αναζήτηση..." />
            </div>
            <div class="searchbox en">
              <ais-search-box placeholder="Search..." />
            </div>
            <ais-hits>
              <template class="outstock" v-slot:item="{ item }">
                <a :href="item.url" class="outofstock">
                  <article>
                    <div class="card-cont">
                      <div class="over">
                        <img :src="item['image']" height="100" />
                        <div class="hit-publication-year">
                          {{ item["name"] }}
                          {{ item["searchable_content"] }}
                        </div>
                        <p>{{ item.price }}€</p>
                        <p class="abs el">
                          <a
                            class="algolia-add-cart"
                            :href="'/cart?add-to-cart=' + item['id']"
                            data-quantity="1"
                            product_sku=""
                            rel="nofollow"
                          >
                            Αγορά
                          </a>
                        </p>
                        <p class="abs en">
                          <a
                            class="algolia-add-cart"
                            :href="'/cart?add-to-cart=' + item['id']"
                            data-quantity="1"
                            product_sku=""
                            rel="nofollow"
                          >
                            Buy
                          </a>
                        </p>
                      </div>
                    </div>
                  </article>
                </a>
              </template>
            </ais-hits>
            <div class="pagination">
              <ais-pagination @page-change="pageChange" />
            </div>
          </div>
        </div>
      </ais-instant-search>
    </div>
  </div>
  <!-- Mobile button -->
</template>

<script>
import TypesenseInstantSearchAdapter from "typesense-instantsearch-adapter";
import VueSlider from "vue-slider-component";
import "vue-slider-component/theme/antd.css";
/* eslint-disable */

import { history as historyRouter } from 'instantsearch.js/es/lib/routers';
function getCategorySlug(name) {
  return name.split(' ').map(encodeURIComponent).join('+');
}

// Returns a name from the category slug.
// The "+" are replaced by spaces and other
// characters are decoded.
function getCategoryName(slug) {
  return slug.split('+').map(decodeURIComponent).join(' ');
}
const routing = {
  router: historyRouter({
    createURL({ qsModule, routeState, location }) {
      const baseUrl = location.pathname.endsWith('/')
        ? location.pathname
        : location.pathname + '/';
      const categoryPath = routeState.category
        ? `${getCategorySlug(routeState.category)}/`
        : '';
      const queryParameters = {};

      if (routeState.query) {
        queryParameters.query = encodeURIComponent(routeState.query);
      }
      if (routeState.page !== 1) {
        queryParameters.page = routeState.page;
      }
      if (routeState.collects) {
        queryParameters.categories = routeState.collects;
      }
      if (routeState.ilikou) {
        queryParameters.paxosilikou = routeState.paxosilikou
          .map(encodeURIComponent)
          .join('~');
      }
      if (routeState.price_min) {
        queryParameters.price_min = routeState.price_min;
      }
      if (routeState.price_max) {
        queryParameters.price_max = routeState.price_max;
      }
      if (routeState.sortBy) {
        queryParameters.sortBy = routeState.sortBy;
      }

      const queryString = qsModule.stringify(queryParameters, {
        addQueryPrefix: true,
        arrayFormat: 'repeat',
      });

      return `${baseUrl}${categoryPath}${queryString}`;
    },

    parseURL({ qsModule, location }) {
      const pathnameMatches = location.pathname.match(/search\/(.*?)\/?$/);
      const category = getCategoryName(
        (pathnameMatches && pathnameMatches[1]) || ''
      );
      const {
        query = '',
        page,
        categories = [],
        paxosilikou = '',
        price_min,
        price_max,
        sortBy,
      } = qsModule.parse(location.search.slice(1));

      const allCollects = Array.isArray(categories)
        ? categories
        : [categories].filter(Boolean);

      const allPaxos = paxosilikou
        ? paxosilikou.split('~').map(decodeURIComponent)
        : [];

      return {
        query: decodeURIComponent(query),
        page,
        collect: allCollects.map(decodeURIComponent),
        paxos: allPaxos,
        price_min,
        price_max,
        sortBy,
        category,
      };
    },
  }),

  stateMapping: {
    stateToRoute(uiState) {
      const indexUiState = uiState['kontou_products_simple'] || {};
      const collects = indexUiState.refinementList?.collect
        ? indexUiState.refinementList.collect.join('~').replace(/ /g, '_')
        : '';

      const price = indexUiState.range?.price || '';
      const pricearray = price.toString().split(':').map(s => s.trim());
      const price_min = pricearray[0];
      const price_max = pricearray[1];

      return {
        query: indexUiState.query ? indexUiState.query.replace(/ /g, '_') : '',
        page: indexUiState.page,
        collects,
        paxosilikou: indexUiState.refinementList?.paxos,
        category: indexUiState.menu?.categories,
        price_min,
        price_max,
        sortBy: indexUiState.sortBy
          ? indexUiState.sortBy.split('/').pop().replace(':', '_')  // ✅ Convert for URL
          : '',
      };
    },

    routeToState(routeState) {
      let t = routeState.collect
        ?.toString()
        .split('~')
        .map(s => s.trim().replace(/_/g, ' ')) || [];
      if (t[0] === '') t = [];

      const price_min = routeState.price_min;
      const price_max = routeState.price_max;
      const prices = price_min + ':' + price_max;

      return {
        kontou_products_simple: {
          query: routeState.query ? routeState.query.replace(/_/g, ' ') : '',
          page: routeState.page,
          menu: {
            categories: routeState.category,
          },
          refinementList: {
            collect: t,
            paxos: routeState.paxos,
          },
          range: { price: prices },
          sortBy: routeState.sortBy
            ? `kontou_products_simple/sort/${routeState.sortBy.replace('_', ':')}` // ✅ Rebuild full index name
            : 'kontou_products_simple',
        },
      };
    },
  },
};
/*
function getCategorySlug(name) {
  return name.split(' ').map(encodeURIComponent).join('+');
}
*/
// Returns a name from the category slug.
// The "+" are replaced by spaces and other
// characters are decoded.
/*function getCategoryName(slug) {
  return slug.split('+').map(decodeURIComponent).join(' ');
}*/
/*
const routing = {
  router: historyRouter({
    windowTitle({ category, query }) {
      const queryTitle = query ? `Results for "${query}"` : 'Search';

      if (category) {
        return `${category} – ${queryTitle}`;
      }

      return queryTitle;
    },

    createURL({ qsModule, routeState, location }) {
      const urlParts = location.href.match(/^(.*?)\/search/);
      const baseUrl = `${urlParts ? urlParts[1] : ''}/`;

      const categoryPath = routeState.category
        ? `${getCategorySlug(routeState.category)}/`
        : '';
      const queryParameters = {};

      if (routeState.query) {
        queryParameters.query = encodeURIComponent(routeState.query);
      }
      if (routeState.page !== 1) {
        queryParameters.page = routeState.page;
      }
      if (routeState.brands) {
        queryParameters.brands = routeState.brands.map(encodeURIComponent);
      }

      const queryString = qsModule.stringify(queryParameters, {
        addQueryPrefix: true,
        arrayFormat: 'repeat',
      });

      return `${baseUrl}search/${categoryPath}${queryString}`;
    },

    parseURL({ qsModule, location }) {
      const pathnameMatches = location.pathname.match(/search\/(.*?)\/?$/);
      const category = getCategoryName(
        (pathnameMatches && pathnameMatches[1]) || ''
      );
      const { query = '', page, brands = [] } = qsModule.parse(
        location.search.slice(1)
      );
      // `qs` does not return an array when there's a single value.
      const allBrands = Array.isArray(brands)
        ? brands
        : [brands].filter(Boolean);

      return {
        query: decodeURIComponent(query),
        page,
        collects: allBrands.map(decodeURIComponent),
        category,
      };
    },
  }),

  stateMapping: {
    stateToRoute(uiState) {
      const indexUiState = uiState['kontou_products_simple'] || {};

      return {
        query: indexUiState.query,
        page: indexUiState.page,
        collect:
          indexUiState.refinementList && indexUiState.refinementList.collect,
        category: indexUiState.menu && indexUiState.menu.categories,
      };
    },

    routeToState(routeState) {
      return {
        instant_search: {
          query: routeState.query,
          page: routeState.page,
          menu: {
            categories: routeState.category,
          },
          refinementList: {
            collect: routeState.collect,
          },
        },
      };
    },
  },
};*/

const typesenseInstantsearchAdapter = new TypesenseInstantSearchAdapter({
  server: {
    apiKey: "hibWH0tnEegT9EReYSlNxPQunaYn27GON6zpXp6BCXS4U2V4",
    nodes: [
      {
        host: "search-node1.anvetogroup.com",
        port: "443",
        protocol: "https",
      },
    ],
  },
  additionalSearchParameters: {
    queryBy: "name, sku",
    num_typos: 3,
  },
});
const searchClient = typesenseInstantsearchAdapter.searchClient;

export default {
  data() {
    /* eslint-disable */
    //const vueRouter = this.$router;
    var flag = false;
    var test = window.location.pathname;
    let uri = window.location.search.substring(1);
    let params = new URLSearchParams(uri);
    var searc = params.get("sr");

    let par1 = test.slice(1);
    let par2 = par1.substring(0, par1.length - 1);
    //var catigoria1 = params.get("category");
    var catigoria1 = par2;

    const appElement = document.getElementById('app');
    var categoryId = [];
      
    var category = appElement.dataset.categoryId;
    categoryId.push(category);
    if(appElement.dataset.categoryId == undefined){
      categoryId = [];
    }
    
    var en = window.location.href.includes("/en");
    return {
      //routing,
      /*routing: {
        router: {
          read() {
            return vueRouter.currentRoute.query;
          },
          write(routeState) {
            vueRouter.push({
              query: routeState,
            });
          },
          createURL(routeState) {
            return vueRouter.resolve({
              query: routeState,
            }).href;
          },
          onUpdate(cb) {
            this._onPopState = () => {
              cb(this.read());
            };
            window.addEventListener('popstate', this._onPopState);
          },
          dispose() {
            window.removeEventListener('popstate', this._onPopState);
            this.write();
          },
        },
        stateMapping: {
          stateToRoute(uiState) {
            return {
              query: uiState.monotikawp_products_simple.query,
              brands:
                uiState.monotikawp_products_simple.refinementList &&
                uiState.monotikawp_products_simple.refinementList.collect &&
                uiState.monotikawp_products_simple.refinementList.collect.join('~'),
              page: uiState.monotikawp_products_simple.page,
            };
          },
          routeToState(routeState) {
            return {
              instant_search: {
                query: routeState.query,
                refinementList: {
                  brand: routeState.brands && routeState.collect.split('~'),
                },
                page: routeState.page,
              },
            };
          },
        },
      },*/
      /*routing: {
        router: historyRouter(),
        stateMapping: {
          stateToRoute(uiState) {
            const indexName = "monotikawp_products_simple";
            const indexUiState = uiState[indexName];
            return {
              subcategory: indexUiState.refinementList && indexUiState.refinementList.collect,  
              page: indexUiState.page,
            };
          },
          routeToState(routeState) {
            return {
              instant_search: {
                refinementList: {
                  subcategory: routeState.collect && routeState.collect.split('~'),
                },
                page: routeState.page,
              },
            };
          },
        },
      },*/
      routing,
    /* working */
      /*routing: {
        router: history(),
        stateMapping: {
          stateToRoute(uiState) {
            const indexName = "kontou_products_simple";
            const indexUiState = uiState[indexName];

            return {
              subcategory: indexUiState.refinementList && indexUiState.refinementList.collect,   
              page: indexUiState.page,
            }
          },
          routeToState(routeState) {
            const indexName = "monotikawp_products_simple";
            return {
              [indexName]: {
                refinementList: {
                  subcategory: routeState.collect,
                },
                page: routeState.page,
              },
            };
          },
        },
      },*/
      
      catigoria1: catigoria1,
      searc: searc,
      searchClient,
      isActive: false,
      hover: false,
      en: en,
      categoryId: categoryId,
      flag: flag,
      /* eslint-disable */
      btn_img: "https://monotika.anvetogroup.com/storage/public/filtra.webp",
      brands: ['Βασικό προϊόν', 'Χρωστικές πατητής 2 συστατικών','Χρωστικές πατητής 1 συστατικού','Βερνίκια','Αστάρια','Επισκευαστικά υλικά','Πατητή τσιμεντοκονία',
      'Μεγέθη', 'Εξαρτήματα πλαστ. κεραμιδιών','Βίδες - Καλύπτρες','Πλαστικά κεραμίδια',
      'Εξηλασμένη λεία', 'Εξηλασμένη με γραμμές','Εξηλασμένη θερμοπρόσοψης', 'Διογκομένη λευκή', 'Διογκομένη γραφιτούχα', 'Κορνίζες εσωτ.χώρου', 'Πολυστερίνες κλπ',
      'Επαγγελματικός εξοπλισμός','Εξαρτήματα γυψοσανίδας', 'Βίδες γυψοσανίδας','Θυρίδες','Κονιάματα γυψοσανίδας','Ορυκτή ίνα'],
    };
  },
  components: {
    VueSlider,
  },
  methods: {
    
    /* eslint-disable */
    transformItems(items) {

      return items.map((item) => ({
        ...item,
        label: item.label.toUpperCase(),
      }));
    },
    encode (value) {
      return he.encode(value);
    },

    /* Mobile filter button show/hide */
    buttonmob(flag) {
      if (this.flag == false) {
        const elem = document.getElementById("search-p");
        elem.classList.add("show");
        this.btn_img =
          "https://monotika.anvetogroup.com/storage/public/x1icon.webp";
        //$('.fil-btn img').attr('src','/wp-content/uploads/2024/11/x1icon.png');
        this.flag = true;
      } else {
        const elem = document.getElementById("search-p");
        elem.classList.remove("show");
        this.btn_img =
          "https://monotika.anvetogroup.com/storage/public/filtra.webp";
        //$('.fil-btn img').attr('src','/wp-content/uploads/2024/11/filtra.webp');
        this.flag = false;
      }
    },
    myFilter: function () {
      this.isActive = !this.isActive;
      if (this.isActive) {
        this.btn_img =
          "https://mato.anvetogroup.com/wp-content/uploads/2023/11/x1icon.png";
      } else {
        this.btn_img =
          "https://mato.anvetogroup.com/wp-content/uploads/2023/11/filtra.png";
      }
    },
    newfuction() {
      alert("test");
    },
    toValue(value, range) {
      return [
        typeof value.min === "number" ? value.min : range.min,
        typeof value.max === "number" ? value.max : range.max,
      ];
    },
    testing2(test1) {
      var c = JSON.parse(test1);
      return "https://monotika.anvetogroup.com/product/" + c["slug"];
    },
    /* Go to top after pagination */
    pageChange() {
      window.scrollTo({ top: 0, behavior: "smooth" });
    },
  },
};
</script>

<style>
.abs {
  margin-top: 40px;
}
.algolia-add-cart {
  margin-top: 20px;
  margin-bottom: 20px;
}
.over {
  margin-bottom: 10px;
}
.show {
  display: block !important;
}
.collectio-re {
  display: none;
}
.card-cont {
  position: relative;
  overflow: visible;
}
.outstock .el {
  display: none !important;
}
.outofstock .outstock p {
  margin: 0px !important;
  font-size: 15px !important;
  padding: 0px !important;
}
.outofstock .outstockimg {
  background-size: cover !important;
  background-image: url(https://sevenseals.gr/wp-content/uploads/2023/09/sold2-removebg-preview.png);
  background-repeat: no-repeat;
  background-position: center top;
  opacity: 1;
  position: relative;
  z-index: 99;
  height: 280px !important;
  width: 100%;
  position: absolute;
  top: 0px !important;
  left: 0px;
  opacity: 0.8;
}
.outofstock .outstock p {
  display: flex;
  align-items: center;
  justify-content: center;
  line-height: 28px;
}
.outofstock .outstock {
  position: absolute;
  font-size: 15px;
  background: black;
  top: 0px;
  left: 0px;
  opacity: 1;
  width: 120px;
  font-size: 15px;
  line-height: px;
  font-weight: 400;
  transform: rotateX(0deg) rotateY(0deg) rotateZ(315deg);
  top: 0px;
  bottom: auto;
  color: rgba(255, 255, 255, 1);
  background: rgba(172, 145, 33, 1);
  width: 160.2px;
  top: 32.2px;
  left: -37.2px;
  right: auto;
  height: 24px;
  line-height: 24px;
}
.ais-Hits-item a {
  width: 100% !important;
}
.outofstock .outstock p {
  color: #fff;
}

#app {
  padding: 50px 20px !important;
}

#app a {
  text-decoration: none;
}
.ais-InstantSearch {
  max-width: 1350px !important;
  gap: 100px;
  margin-left: auto;
  margin-right: auto;
  display: flex !important;
}
.search-panel {
  width: 100% !important;
  display: flex !important;
}
.ais-Hits-list {
  display: flex !important;
  flex-wrap: wrap;
  padding-left: 0px !important;
  justify-content: center;
}
.search-panel__filters {
  width: 22%;
}
.search-panel__results {
  width: 100% !important;
}
/* Mobile button */
.fil-btn {
  animation-duration: 0.7s;
  display: flex !important;
  position: fixed;
  bottom: 50px !important;
  background: #1f4375;
  align-items: center;
  justify-content: center;
  color: #fff;
  border-radius: 50%;
  z-index: 9999 !important;
  display: none !important;
  width: 60px !important;
  height: 60px !important;
}

.fil-btn img {
  width: 40px !important;
  padding: 10px;
}
.filtra-title {
  border-bottom: 1px solid #d9dde5 !important;
  margin-bottom: 20px !important;
}
/**/
/* Search input */
.ais-SearchBox {
  display: flex;
  justify-content: center;
  margin-bottom: 30px;
}
.ais-SearchBox-submit {
  right: 1.3rem;
  left: auto;
  background: transparent;
  border: none !important;
  position: absolute;
  right: 15px;
  top: 50%;
  transform: translate(0%, -50%);
}
.ais-SearchBox-submit svg {
  width: 18px !important;
  height: auto !important;
}
.ais-SearchBox-input {
  width: 100% !important;
  padding: 10px 20px;
  border-radius: 15px;
  outline: none !important;
  background: #f5f5f5 !important;
  font-size: 16px !important;
}
.ais-SearchBox-reset,
.ais-SearchBox-reset svg,
.ais-SearchBox-input[type="search"]::-webkit-search-cancel-button {
  display: none !important;
}
.ais-SearchBox-form {
  width: 100% !important;
  position: relative !important;
}
.ais-SearchBox-input:focus {
  outline: none !important;
}
.ais-SearchBox-input {
  outline: none !important;
  border: 0 !important;
}
/**/

/* Filter inputs */
.ais-RefinementList-item,
.ais-HierarchicalMenu-item {
  position: relative;
}
.ais-RefinementList-label {
  display: flex !important;
  color: black;
  align-items: center !important;
}
.ais-RefinementList-showMore:hover {
  background: transparent !important;
  color: #cf6a1b;
}
.ais-RefinementList-showMore:focus {
  border: none !important;
  outline: none !important;
}
.ais-RefinementList,
.ais-RangeInput {
  border-bottom: 1px solid #d9dde5 !important;
}

.ais-RangeInput {
  padding-left: 10px;
  padding-right: 10px;
  padding-bottom: 20px !important;
}

/* Hierarchical input */
.ais-HierarchicalMenu-link {
  text-decoration: none !important;
  color: #222 !important;
}
.ais-HierarchicalMenu-link:hover {
  color: #222 !important;
}
.ais-HierarchicalMenu-list .ais-HierarchicalMenu-list {
  margin-left: 1em !important;
}
.ais-HierarchicalMenu-item {
  padding-top: 10px;
  padding-bottom: 10px;
}

.ais-HierarchicalMenu-count,
.ais-Menu-count,
.ais-RefinementList-count,
.ais-ToggleRefinement-count {
  font-size: 0px;
  position: absolute;
  top: 10px;
  left: 0;
  height: 22px;
  width: 22px;
  background-color: #eee;
  border-radius: 50%;
}
.ais-HierarchicalMenu-label {
  margin-left: 40px;
}
.ais-HierarchicalMenu-item {
  position: relative;
}

.product-link {
  text-decoration: none;
}
/**/
/* Pagination */
.ais-Pagination {
  margin-top: 40px !important;
}
.ais-Pagination-item {
  height: 50px !important;
  border-radius: 0px;
  border: 1px solid #e9e9e9 !important;
  margin-left: 0px !important;
  display: flex !important;
}
.ais-Pagination-link {
  border-radius: 0px;
  padding: 10px;
  color: #1f4375;
  height: 50px !important;
  padding-top: 0px !important;
  padding-bottom: 0px !important;
  display: flex !important;
  align-items: center;
  text-decoration: none !important;
}
.ais-Pagination-list {
  display: flex;
  list-style: none;
  justify-content: center;
}
.ais-Pagination-item:hover a {
  color: #1f4375;
}
.ais-Pagination-item--selected .ais-Pagination-link {
  color: #fff;
  background-color: #1f4375;
  border-color: #1f4375;
}
.ais-Pagination-item--selected .ais-Pagination-link:hover {
  color: #fff !important;
}
/**/
/* Products Results */
.card-cont {
  padding-bottom: 10px !important;
}
.hit-authors,
.hit-publication-year {
  padding-bottom: 10px !important;
  padding-top: 20px !important;
  color: #000 !important;
}
.ais-InfiniteHits-item,
.ais-InfiniteResults-item,
.ais-Hits-item,
.ais-Results-item {
  width: 28% !important;
}

.ais-Hits-item {
  text-align: center;
  margin-bottom: 0px !important;
  border-radius: 20px;
  text-align: center !important;
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.ais-Hits-item article {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100% !important;
}

.ais-Hits-item img {
  background: #ffffff;
  width: 100% !important;
  height: 280px !important;
  object-fit: contain !important;
  box-shadow: 0 7px 12px rgb(97 45 0 / 21%) !important;
  border-radius: 10px !important;
}

.ais-Hits-item {
  cursor: pointer;
  align-items: center;
  margin-bottom: 20px;
  background: #eceaea;
  padding: 15px;
  padding-bottom: 30px !important;
  border-radius: 5px;
  display: flex;
  box-shadow: 0 7px 12px rgb(97 45 0 / 21%) !important;
}
.ais-Hits-item h1 {
  font-size: 22px !important;
  margin: 0;
  font-weight: 400 !important;
  margin-bottom: 15px !important;
  margin-top: 15px !important;
  color: #222 !important;
}

.ais-Hits-item h1 .ais-Highlight {
  font-size: 22px !important;
  margin: 0;
  font-weight: 400 !important;
  margin-bottom: 5px !important;
  margin-top: 15px !important;
  color: #222 !important;
}
.hit-rating {
  font-size: 18px !important;
  color: #102747;
  font-weight: 700 !important;
  margin-bottom: 15px;
}
.ais-Hits-item h2 {
  font-size: 22px;
  margin: 0;
  font-weight: 400 !important;
  margin-bottom: 5px !important;
  margin-top: 15px !important;
}

.ais-Hits-item p {
  font-size: 18px;
  color: #000;
  font-weight: 700 !important;
  margin-bottom: 15px;
}
/**/
/* Add to cart */
.card-btn {
  line-height: 60px !important;
  margin-top: auto !important;
}
.algolia-add-cart {
  border-radius: 20px !important;
  background: linear-gradient(
    to bottom right,
    #2e3654,
    #3c497d,
    #a3afff,
    #3c497d,
    #2e3654
  ) !important;
  padding: 12px 25px !important;
  font-size: 18px !important;
  margin-top: 20px;
  margin-bottom: 20px;
  color: #fff !important;
  text-decoration: none !important;
}

.algolia-add-cart:hover {
  background: linear-gradient(to right, #3b3c3c, #959799) !important;
}

/* Sort by input */
.ais-SortBy {
  padding-bottom: 20px !important;
  margin-bottom: 20px !important;
  border-bottom: 1px solid #d9dde5 !important;
}

.ais-SortBy-select:focus {
  border: 1px solid #c4c8d8 !important;
  outline: 0 !important;
  box-shadow: 0 0 0 0rem black;
}

.ais-SortBy-select {
  border: 1px solid #c4c8d8 !important;
  font-size: 16px !important;
  border-radius: 2px;
  padding: 10px 20px;
  width: 100%;
  background-color: #eceaea;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  padding: 10px 20px;
}
/**/

/* Header styling */
.search-panel h2 {
  font-size: 20px;
  font-weight: 400;
  color: black;
}
.filtra-title h2 {
  margin-top: 0px;
}
.search-panel h4 {
  font-size: 22px !important;
}
/**/

/* Custom checkboxes */
.ais-RefinementList-list,
.ais-HierarchicalMenu-list {
  list-style: none;
  display: block;
  position: relative;
  margin-bottom: 12px;
  cursor: pointer;
  padding-left: 0px !important;
  font-size: 22px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
.ais-RefinementList-labelText,
.ais-HierarchicalMenu-label {
  font-size: 16px;
  margin-left: 40px;
}
/* Hide the browser' s default checkbox */
.ais-RefinementList-list input,
.ais-HierarchicalMenu-list input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
}

.ais-HierarchicalMenu-list {
  padding-bottom: 20px !important;
}

/* Create a custom checkbox */
.ais-RefinementList-count,
.ais-HierarchicalMenu-count {
  font-size: 0px;
  position: absolute;
  top: 10px;
  left: 0;
  height: 22px;
  width: 22px;
  background-color: #eee;
  border-radius: 50%;
}
.ais-Hits-list {
  gap: 20px;
  margin-top: 0px !important;
}

.ais-InfiniteHits-item,
.ais-InfiniteResults-item,
.ais-Hits-item,
.ais-Results-item {
  border: 0px solid !important;
}
.ais-RefinementList-item,
.ais-HierarchicalMenu-item {
  cursor: pointer;
  padding-top: 10px;
  padding-bottom: 10px;
}

.ais-Highlight {
  font-size: 18px;
  color: #222 !important;
}

.ais-Highlight,
.ais-RefinementList-count,
.ais-HierarchicalMenu-count {
  cursor: pointer;
}
/* When the checkbox is checked, add a blue background */
.ais-RefinementList-list input:checked ~ .ais-RefinementList-count,
.ais-HierarchicalMenu-list
  .ais-HierarchicalMenu-link--selected
  .ais-HierarchicalMenu-count {
  background-color: #3c497d;
}

/* Create the checkmark/indicator (hidden when not checked) */
.ais-RefinementList-count:after,
.ais-HierarchicalMenu-count:after {
  content: "";
  position: absolute;
  display: none;
}

/* Show the checkmark when checked */
.ais-RefinementList-list input:checked ~ .ais-RefinementList-count:after,
.ais-HierarchicalMenu-list
  .ais-HierarchicalMenu-link--selected
  .ais-HierarchicalMenu-count:after {
  display: block;
}

/* Style the checkmark/indicator */
.ais-RefinementList-list .ais-RefinementList-count:after,
.ais-HierarchicalMenu-list .ais-HierarchicalMenu-count:after {
  left: 7px;
  top: 5px;
  width: 5px;
  height: 8px;
  border: solid white;
  border-width: 0 3px 3px 0;
  -webkit-transform: rotate(45deg);
  -ms-transform: rotate(45deg);
  transform: rotate(45deg);
}

/* Show more link */
.ais-RefinementList-showMore {
  background: transparent !important;
  padding: 0px 0px !important;
  font-size: 17px !important;
  color: #3c497d !important;
  text-decoration: none !important;
  padding-bottom: 20px !important;
  border: none !important;
}
/* slider */
.vue-slider-dot-tooltip-inner {
  border-color: #3c497d;
  background-color: #3c497d;
}

/* Mobile */
@media only screen and (max-width: 1450px) {
  #app {
    padding-left: 30px;
    padding-right: 30px;
  }
}

@media only screen and (max-width: 1300px) {
  .ais-InfiniteHits-item,
  .ais-InfiniteResults-item,
  .ais-Hits-item,
  .ais-Results-item {
    width: 40% !important;
  }
}

@media only screen and (max-width: 992px) {
  .ais-RefinementList-item {
    display: flex;
    justify-content: center;
  }
  .ais-SearchBox-form {
    width: 95% !important;
    position: relative !important;
  }
  .ais-Hits-list {
    justify-content: center;
    margin-left: 0px !important;
  }
  .card-btn {
    margin-top: 20px !important;
  }
  #app {
    padding-top: 20px !important;
    padding-bottom: 20px !important;
    padding-left: 0px !important;
    padding-right: 0px !important;
  }
  .last {
    margin-bottom: 10px !important;
  }
  .filtra-title {
    margin-top: 40px !important;
  }
  .ais-RefinementList-labelText {
    margin-left: 0px !important;
  }
  .fil-btn {
    display: block !important;
  }
  .ais-Hits-list {
    padding-left: 0px !important;
  }
  .search-panel__filters {
    display: none;
    padding-left: 10%;
    padding-right: 10%;
    width: 100%;
    text-align: center !important;
    margin-right: 0px !important;
    position: fixed;
    top: 0;
    background: #fffbfc;
    z-index: 999;
    width: 100%;
    left: 0;
    height: 100%;
    overflow: scroll !important;
    -webkit-animation: slide-in-right 0.7s cubic-bezier(0.25, 0.46, 0.45, 0.94)
      both;
    animation: slide-in-right 0.7s cubic-bezier(0.25, 0.46, 0.45, 0.94) both;
  }
  .search-panel__results {
    margin-left: 0px !important;
  }
  @-webkit-keyframes slide-in-right {
    0% {
      -webkit-transform: translateX(1000px);
      transform: translateX(1000px);
      opacity: 1;
    }
    100% {
      -webkit-transform: translateX(0);
      transform: translateX(0);
      opacity: 1;
    }
  }
  @keyframes slide-in-right {
    0% {
      -webkit-transform: translateX(1000px);
      transform: translateX(1000px);
      opacity: 1;
    }
    100% {
      -webkit-transform: translateX(0);
      transform: translateX(0);
      opacity: 1;
    }
  }
  .true {
    display: block !important;
  }

  .ais-InfiniteHits-item,
  .ais-InfiniteResults-item,
  .ais-Hits-item,
  .ais-Results-item {
    width: 90% !important;
  }

  .ais-Hits-item {
    margin-bottom: 30px !important;
  }
  .ais-InstantSearch .left-panel {
    width: 100%;
    text-align: center !important;
  }

  .ais-InstantSearch .right-panel {
    width: 78%;
    margin-left: auto;
    margin-right: auto;
  }

  .ais-InstantSearch {
    flex-direction: column-reverse !important;
    justify-content: center !important;
    gap: 40px;
  }
}

@media only screen and (max-width: 600px) {
  .ais-SearchBox-form {
    width: 100% !important;
  }
}
</style>
